import { AccountRestrictionDto, AccountRestrictionModel } from '../types/account-restriction'

export const transformAccountRestrictionDto = (
  accountRestrictionDto?: AccountRestrictionDto,
): AccountRestrictionModel => {
  if (!accountRestrictionDto) return null

  return {
    action: accountRestrictionDto.action,
    expirationDate: accountRestrictionDto.expiration_date,
  }
}
